import React from 'react';

// Short, unique tag for a member shown next to their first name, so two
// people with the same name (e.g. two Pauls) can be told apart: the last 6
// characters of their userId. Hover shows the full userId.
export const shortId = (userId) => (userId ? `#${String(userId).slice(-6)}` : '');

const ShortId = ({ userId }) => (userId ? (
  <span
    title={`userId ${userId}`}
    style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: '0.75em', color: '#64748b', fontWeight: 400, marginLeft: '0.3em' }}
  >
    {shortId(userId)}
  </span>
) : null);

export default ShortId;
